import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Typography
} from '@mui/material';
import React from 'react';

export default function PackageDetailsMovementTab({ movementHistory }) {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
  };

  const getStatusColor = (inputType) => {
    switch (inputType?.toLowerCase()) {
      case 'delivered':
        return 'success';
      case 'in transit':
      case 'picked up':
        return 'primary';
      case 'exception':
      case 'delayed':
        return 'error';
      case 'out for delivery':
        return 'warning';
      default:
        return 'default';
    }
  };

  if (!movementHistory || movementHistory.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="h6" color="text.secondary">
          No movement history available
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Movement data will appear here when available from
          ZoeShipmentTrackingLog
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
        Movement History ({movementHistory.length} records)
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {movementHistory.map((record, index) => (
          <Card key={record.Id || index} elevation={2} sx={{ borderRadius: 2 }}>
            <CardContent>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  mb: 2
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                    <Chip
                      label={record.InputType || 'Unknown Status'}
                      color={getStatusColor(record.InputType)}
                      size="small"
                      sx={{ mr: 1 }}
                    />
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {formatDate(record.CollectedDate)}
                  </Typography>
                </Box>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                  gap: 2
                }}
              >
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: 'text.secondary' }}
                  >
                    Tracking Number
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    {record.TrackingNumber || 'N/A'}
                  </Typography>

                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: 'text.secondary' }}
                  >
                    Source
                  </Typography>
                  <Typography variant="body2">
                    {record.Source || 'N/A'}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: 'text.secondary' }}
                  >
                    User ID
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    {record.UserId || 'N/A'}
                  </Typography>

                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: 'text.secondary' }}
                  >
                    Shipment Tracking ID
                  </Typography>
                  <Typography variant="body2">
                    {record.ZoeShipmentTrackingId || 'N/A'}
                  </Typography>
                </Box>
              </Box>

              {record.Note && (
                <>
                  <Divider sx={{ my: 2 }} />
                  <Box>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, color: 'text.secondary', mb: 1 }}
                    >
                      Notes
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        backgroundColor: 'grey.50',
                        p: 1.5,
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'grey.200'
                      }}
                    >
                      {record.Note}
                    </Typography>
                  </Box>
                </>
              )}
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
